import React from "react";
import "./Payment.scss";

// ✅ Correct & verified icon imports
import { FaReact, FaNodeJs, FaDatabase, FaGithub } from "react-icons/fa";
import { TbApi } from "react-icons/tb";

const Payment = () => {
  const modules = [
    { id: 1, icon: <FaReact />, label: "Frontend", color: "#61DBFB" },
    { id: 2, icon: <FaNodeJs />, label: "Backend", color: "#3C873A" },
    { id: 3, icon: <TbApi  />, label: "API Integration", color: "#FFAA00" },
    { id: 4, icon: <FaDatabase />, label: "Database", color: "#0078D7" },
    { id: 5, icon: <FaGithub />, label: "Version Control", color: "#000000" },
  ];

  return (
    <section className="payment-section">
      <div className="circle-container">
        <div className="core">
          <h3>Web Development</h3>
          <p>Complete Stack Workflow</p>
        </div>

        <div className="orbit">
          {modules.map((item) => (
            <div key={item.id} className="module" style={{ borderColor: item.color }}>
              <div className="icon" style={{ color: item.color }}>
                {item.icon}
              </div>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Payment;
